/***************************************************************
Hawaiian Macadamia Nut Services
Alexander Self
3/31/20
Profile Card
- Displays simple information about a user
***************************************************************/
import React from 'react';
import moment from 'moment';


const ProfileCard = ({ employee }) => {
  if (!employee.eid) return <div></div>;
  return (
    <div className="card light-blue" id={'lastVisited'}>
      <div className="card-content white-text">
        <span className="card-title">About Me!</span>
        <p>
          I started with the company on <b>{ moment(employee.hireDate).format("dddd, MMMM Do YYYY") }</b>.
          I am a <b>{ employee.type === 'SAL' ? 'salaried' : 'hourly' } { employee.positionType }</b> employee{'\u00A0'}
          and work in the <b>{ employee.department }</b> department.
        </p>

      </div>
    </div>
  )
}

export default ProfileCard;




















/* END */



// WEBPACK FOOTER //
// ./src/components/profiles/view/profile_card.js